const zh: Record<string, string> = {
  // App
  'app.title': '聊讯管理后台',
  'app.loading': '加载中...',

  // Login
  'login.title': '聊讯管理后台',
  'login.subtitle': '管理员登录',
  'login.username': '用户名',
  'login.username_placeholder': '请输入用户名',
  'login.password': '密码',
  'login.password_placeholder': '请输入密码',
  'login.submit': '登录',
  'login.loading': '登录中...',
  'login.network_error': '网络错误，请重试',

  // Navigation
  'nav.dashboard': '仪表板',
  'nav.users': '用户管理',
  'nav.spaces': '群组管理',
  'nav.reports': '举报管理',
  'nav.platform_config': '系统设置',
  'nav.admin_management': '子账号管理',
  'nav.audit_logs': '审计日志',

  // Layout
  'layout.admin': '管理员',
  'layout.logout': '退出登录',

  // Language
  'lang.zh': '中文',
  'lang.en': 'English',
  'lang.switch': '切换语言',

  // Common
  'common.loading': '加载中...',
  'common.save': '保存',
  'common.cancel': '取消',
  'common.clear_all_filters': '清除',
  'common.confirm': '确认',
  'common.apply': '应用',
  'common.close': '关闭',
  'common.warning': '警告',
  'common.delete': '删除',
  'common.edit': '编辑',
  'common.create': '创建',
  'common.update': '更新',
  'common.search': '搜索',
  'common.all': '全部',
  'common.active': '活跃',
  'common.inactive': '不活跃',
  'common.enabled': '启用',
  'common.disabled': '禁用',
  'common.status': '状态',
  'common.actions': '操作',
  'common.show_less': '收起',
  'common.show_more_media': '再显示 {count} 张图片',
  'common.name': '名称',
  'common.description': '描述',
  'common.username': '用户名',
  'common.display_name': '显示名称',
  'common.password': '密码',
  'common.email': '邮箱',
  'common.role': '角色',
  'common.created_at': '创建时间',
  'common.saving': '保存中...',
  'common.save_success': '保存成功',
  'common.save_failed': '保存失败',
  'common.create_failed': '创建失败',
  'common.update_failed': '更新失败',
  'common.operation_failed': '操作失败',
  'common.no_data': '暂无数据',
  'common.prev_page': '上一页',
  'common.next_page': '下一页',
  'common.page_info': '第 {page} / {totalPages} 页',
  'common.vs_last_month': 'vs 上月',
  'common.public': '公开',
  'common.private': '私密',
  'common.yes': '是',
  'common.no': '否',
  'common.copied': '已复制',
  'common.copy': '复制',
  'common.upload': '上传',
  'common.uploading': '上传中...',
  'common.remove': '移除',
  'common.generating': '生成中...',
  'common.generate_new_link': '生成新链接',
  'common.save_changes': '保存更改',
  'common.optional': '可选',
  'common.view_image': '查看图片',
  'common.view_avatar': '查看头像',
  'common.view_member_detail': '查看成员详情',
  'common.view_room_detail': '查看聊天室详情',

  // Dashboard
  'dashboard.title': '仪表板',
  'dashboard.welcome': '欢迎回来，这是您的聊讯平台概览',
  'dashboard.total_users': '总用户数',
  'dashboard.active_rooms': '活跃群聊',
  'dashboard.pending_reports': '待处理举报',
  'dashboard.today_messages': '今日消息量',
  'dashboard.rebuild_stats': '刷新统计',
  'dashboard.rebuilding': '刷新中...',
  'dashboard.user_growth': '用户增长趋势',
  'dashboard.weekly_activity': '本周活跃度',
  'dashboard.recent_activity': '最近活动',
  'dashboard.new_registration': '新用户注册',
  'dashboard.new_registration_desc': '{count}位新用户在过去1小时内注册',
  'dashboard.new_registration_desc_dynamic':
    '过去24小时内有{count}位新用户注册，最新: {name}',
  'dashboard.new_report': '新举报提交',
  'dashboard.new_report_desc': '群聊「公众群 - 万事屋」收到不当内容举报',
  'dashboard.new_report_desc_dynamic':
    '{count}条新举报，最新来自群聊「{room}」',
  'dashboard.hot_room': '热门群聊',
  'dashboard.hot_room_desc': '群聊「群聊1 - 工作群」消息量突破10万条',
  'dashboard.hot_room_desc_dynamic': '「{room}」今日有{count}条消息',
  'dashboard.user_banned': '用户封禁',
  'dashboard.user_banned_desc': '管理员封禁了3个违规账户',
  'dashboard.user_banned_desc_dynamic': '过去24小时内封禁了{count}个用户',
  'dashboard.5min_ago': '5分钟前',
  'dashboard.12min_ago': '12分钟前',
  'dashboard.1hour_ago': '1小时前',
  'dashboard.2hours_ago': '2小时前',
  'dashboard.just_now': '刚刚',
  'dashboard.min_ago': '分钟前',
  'dashboard.hours_ago': '小时前',
  'dashboard.mon': '周一',
  'dashboard.tue': '周二',
  'dashboard.wed': '周三',
  'dashboard.thu': '周四',
  'dashboard.fri': '周五',
  'dashboard.sat': '周六',
  'dashboard.sun': '周日',
  'dashboard.month': '{n}月',
  'dashboard.user_count': '用户数',
  'dashboard.message_count': '消息量',
  'dashboard.no_recent_activity': '暂无最近活动',
  'dashboard.activity.new_registration': '新用户注册',
  'dashboard.activity.new_registration_desc':
    '过去1小时内有 {count} 位新用户注册',
  'dashboard.activity.new_report': '新举报提交',
  'dashboard.activity.new_report_desc': '过去24小时内有 {count} 条新举报',
  'dashboard.activity.trending_room': '热门群聊',
  'dashboard.activity.trending_room_desc': '「{name}」今日消息活跃',
  'dashboard.activity.user_banned': '用户封禁',
  'dashboard.activity.user_banned_desc': '管理员封禁了 {count} 个违规账户',

  // User Management
  'users.title': '用户管理',
  'users.subtitle': '管理平台所有用户账户',
  'users.add_user': '添加用户',
  'users.total_users': '总用户数',
  'users.active_users': '活跃用户',
  'users.banned': '已封禁',
  'users.new_today': '今日新增',
  'users.search_placeholder': '搜索用户名...',
  'users.user': '用户',
  'users.join_date': '加入日期',
  'users.phone_number': '手机号码',
  'users.email': '邮箱',
  'users.rooms_joined': '参与群聊',
  'users.groups': '群组',
  'users.message_count': '消息数',
  'users.rooms_count': '{count} 个群聊',
  'users.messages_count': '{count} 条',
  'users.view_detail': '查看详情',
  'users.send_notification': '发送通知',
  'users.view_groups': '查看群组',
  'users.ban_user': '封禁用户',
  'users.unban_user': '解封用户',
  'users.delete_account': '删除账户',
  'users.edit_user': '编辑用户',
  'users.create_user': '添加新用户',
  'users.create_user_desc': '创建一个新的用户账户',
  'users.username_placeholder': '输入用户名...',
  'users.display_name_placeholder': '输入用户名称...',
  'users.mobile_placeholder': '输入手机号码...',
  'users.password_placeholder': '输入密码...',
  'users.mobile_number': '手机号',
  'users.password_keep': '密码（留空保持不变）',
  'users.back_to_list': '返回用户列表',
  'users.member': '成员',
  'users.space_owner': '群组所有者',
  'users.space_admin': '群组管理员',
  'users.user_info': '用户信息',
  'users.location': '位置',
  'users.last_active': '最后活跃',
  'users.user_role': '用户角色',
  'users.rooms_participated': '参与的群聊',
  'users.activity_log': '活动记录',
  'users.no_rooms': '暂无群聊数据',
  'users.no_activity': '暂无活动记录',
  'users.report_history': '举报记录',
  'users.reported_for': '被举报 - {type}',
  'users.report_in_room': '在群聊「{room}」中发送违规消息',
  'users.no_reports': '暂无举报记录',
  'users.friends': '好友',
  'users.blocked': '黑名单',
  'users.no_friends': '暂无好友',
  'users.view_chat': '查看聊天',
  'users.no_blocks': '暂无屏蔽用户',
  'users.report_status_pending': '待处理',
  'users.report_status_reviewing': '审核中',
  'users.report_status_resolved': '已驳回',
  'users.report_status_rejected': '已拒绝',
  'users.group_room': '群组群聊',
  'users.direct_message': '私聊',
  'users.group_roles': '群组角色',
  'users.role_member': '普通成员',
  'users.role_owner': '群组所有者',
  'users.role_admin': '群聊管理员',
  'users.user_list': '用户列表',

  'users.daily_avg_messages': '日均消息',
  'users.total_logins': '总登录次数',
  'users.delete_title': '删除账户',
  'users.delete_confirm': '此操作不可撤销，确认删除用户 {name} 的账户？',
  'users.delete_warning': '警告',
  'users.delete_warning_text':
    '删除账户将永久移除该用户的所有数据，包括消息记录、群组成员资格等。此操作无法恢复。',
  'users.confirm_delete': '确认删除',
  'users.delete_blocked_space_owner': '该用户是空间所有者',
  'users.delete_blocked_space_owner_text':
    '空间不能没有所有者。请先将其空间的所有权转让给其他成员，再删除该账户。',
  'users.ban_title': '封禁用户',
  'users.ban_confirm': '确认封禁用户 {name}?',
  'users.ban_reason': '封禁原因',
  'users.ban_reason_placeholder': '请输入封禁原因...',
  'users.confirm_ban': '确认封禁',
  'users.ban_warning_title': '警告',
  'users.ban_warning':
    '封禁用户后，该用户将无法登录和使用平台功能。此操作可以在用户管理中撤销。',
  'users.mute_user': '禁言用户',
  'users.unmute_user': '解除禁言',
  'users.mute_title': '禁言用户',
  'users.mute_confirm': '确认禁言用户 {name}？该用户将无法发送消息。',
  'users.mute_reason': '禁言原因',
  'users.mute_reason_placeholder': '请输入禁言原因...',
  'users.mute_duration': '禁言时长',
  'users.mute_indefinite': '永久',
  'users.mute_1_hour': '1 小时',
  'users.mute_24_hours': '24 小时',
  'users.mute_7_days': '7 天',
  'users.mute_30_days': '30 天',
  'users.mute_custom': '自定义',
  'users.confirm_mute': '确认禁言',
  'users.mute_warning_title': '禁言用户',
  'users.mute_warning': '禁言后，该用户将无法在平台上发送任何消息或图片。',
  'users.muted': '已禁言',
  'users.muted_until': '禁言至 {date}',
  'users.muted_indefinitely': '永久禁言',
  'users.user_rooms': '用户群聊',
  'users.user_rooms_desc': '{name} 参与的所有群聊',
  'users.members': '成员',
  'users.notify_title': '发送通知',
  'users.notify_desc': '向 {name} 发送系统通知',
  'users.notify_subject': '标题',
  'users.notify_subject_placeholder': '通知标题',
  'users.notify_content': '内容',
  'users.notify_content_placeholder': '通知内容...',
  'users.sending': '发送中...',
  'users.bio': '专注于技术交流和项目协作',

  // Space Management
  'spaces.title': '群组管理',
  'spaces.subtitle': '管理群组和群组内的群聊',
  'spaces.add_space': '添加群组',
  'spaces.total_spaces': '总群组数',
  'spaces.space_members': '群组成员',
  'spaces.room_count': '群聊数',
  'spaces.today_messages': '今日消息',
  'spaces.search_placeholder': '搜索群组名称或群组所有者...',
  'spaces.space_name': '群组名称',
  'spaces.space_owner': '群组所有者',
  'spaces.member_count': '成员数',
  'spaces.rooms': '群聊',
  'spaces.rooms_count': '{count} 个群聊',
  'spaces.type': '类型',
  'spaces.type_public': '公众群组',
  'spaces.type_private': '私密群组',
  'spaces.back_to_list': '返回群组列表',
  'spaces.reported': '已停用',
  'spaces.owner_label': '所有者:',
  'spaces.created_at': '创建于 {date}',
  'spaces.edit_info': '编辑群组',
  'spaces.transfer_ownership': '转让所有权',
  'spaces.manage_admins': '管理管理员',
  'spaces.add_room': '添加群聊',
  'spaces.add_member': '添加成员',
  'spaces.add_member_title': '添加群组成员',
  'spaces.add_member_desc': '搜索并添加用户到群组「{name}」',
  'spaces.select_users': '搜索用户',
  'spaces.select_user_placeholder': '搜索用户名或昵称...',
  'spaces.no_members_selected': '请从上方搜索并选择要添加的用户',
  'spaces.confirm_add_members': '添加 {count} 名成员',
  'spaces.total_messages': '总消息数',
  'spaces.active_rooms': '活跃群聊',
  'spaces.member_list_title': '成员列表',
  'spaces.total_count': '共 {count} 位成员',
  'spaces.total_member_count': '总成员数',
  'spaces.admin_count': '管理员',
  'spaces.active_member_count': '活跃成员',
  'spaces.space_created_date': '创建日期',
  'spaces.back_to_detail': '返回群组详情',
  'spaces.search_member_placeholder': '搜索成员名称、用户名ID...',
  'spaces.filter_all_members': '全部成员',
  'spaces.filter_admins': '管理员',
  'spaces.filter_members': '普通成员',
  'spaces.member_name': '成员',
  'spaces.join_date': '加入日期',
  'spaces.last_active': '最后活跃',
  'spaces.role_owner': '所有者',
  'spaces.role_admin': '管理员',
  'spaces.role_member': '普通成员',
  'spaces.view_space_members': '查看成员',

  // Member actions
  'members.view_user_detail': '查看用户详情',
  'members.set_admin': '设为管理员',
  'members.remove_admin': '取消管理员',
  'members.remove_member': '移除成员',
  'members.confirm_set_admin': '确认将 {name} 设为管理员？',
  'members.confirm_remove_admin': '确认取消 {name} 的管理员身份？',
  'members.confirm_remove_member':
    '确认将 {name} 从该群组中移除？此操作不可撤销。',
  'spaces.search_rooms': '搜索群组聊天名称或管理员...',
  'spaces.room_name': '群组名称',
  'spaces.admin': '管理员',
  'spaces.message_count': '消息数',
  'spaces.view_detail': '查看详情',
  'spaces.assign_admin': '分配管理员',
  'spaces.view_members': '查看成员',
  'spaces.delete_space': '删除群组',
  'spaces.confirm_delete_space': '确认删除群组「{name}」？此操作无法撤销。',
  'spaces.toggle_status_title': '确认操作',
  'spaces.toggle_status_confirm': '确认{action}群组「{name}」？',
  'spaces.mute_room': '静音群组',
  'spaces.delete_room': '删除群组',
  'spaces.no_rooms': '暂无群聊',
  'spaces.view': '查看',
  'spaces.deactivate': '停用',
  'spaces.activate': '启用',
  'spaces.create_space': '添加新群组',
  'spaces.name_required': '群组名称',
  'spaces.space_name_placeholder': '输入群组名称',
  'spaces.name_must_be_unique': '名称不能重复',
  'spaces.space_desc_placeholder': '输入群组描述',
  'spaces.description_label': '群组描述',
  'spaces.visibility': '群组类型',
  'spaces.visibility_private_desc': '需要邀请链接或邀请码才能加入',
  'spaces.visibility_public_desc': '所有用户可见，可查看所有公开群聊',
  'spaces.select_visibility': '选择可见性',
  'spaces.join_rule': '加入规则',
  'spaces.select_join_rule': '选择加入规则',
  'spaces.join_open': '开放',
  'spaces.join_invite_only': '仅邀请',
  'spaces.join_invitation_code': '邀请码加入',
  'spaces.join_approval': '需审批',
  'spaces.join_not_set': '未设置',
  'spaces.select_owner': '选择群组所有者',
  'spaces.owner_must_select_existing': '必须从现有用户中选择',
  'spaces.search_users': '搜索用户...',
  'spaces.require_verification': '需要账户验证',
  'spaces.verification_url': '验证 URL',

  // Space Detail
  'spaces.edit_space_title': '编辑群组',
  'spaces.edit_space': '编辑群组',
  'spaces.edit_space_desc': '修改群组的基本信息和设置',
  'spaces.create_space_desc':
    '创建一个新的群组，群组所有者可以在群组内创建多个群聊。',
  'spaces.save_changes': '保存更改',
  'spaces.rules': '规则',
  'spaces.rules_placeholder': '输入群组规则',
  'spaces.category': '分类',
  'spaces.no_category': '无分类',
  'spaces.transfer_title': '转让群组所有权',
  'spaces.transfer_desc': '为 {name} 指定新的所有者',
  'spaces.current_owner': '当前所有者',
  'spaces.select_new_owner': '选择新所有者',
  'spaces.select_from_owners': '从空间所有者中选择',
  'spaces.select_from_members': '从空间管理员中选择',
  'spaces.transfer_note': '转让后，新所有者将拥有该群组的全部管理权限',
  'spaces.transfer_notice_title': '重要提示',
  'spaces.transfer_notice_text':
    '此操作将把群组的全部管理权限转移给新的所有者。转让后您将失去对该群组的所有者权限。',
  'spaces.confirm_transfer': '确认转让',
  'spaces.batch_mute': '批量禁言',
  'spaces.batch_mute_success': '成功禁言 {count} 个群聊',
  'spaces.unmute': '取消禁言',
  'spaces.member_mute': '成员禁言',
  'spaces.full_mute': '全体禁言',

  // Room Detail
  'rooms.detail_title': '群聊详情 — {name}',
  'rooms.description': '描述',
  'rooms.member_count': '成员数',
  'rooms.is_private': '私密',
  'rooms.created_at': '创建时间',
  'rooms.message_history': '消息记录',
  'rooms.message_total': '({count} 条)',
  'rooms.deleted': '已删除',
  'rooms.image': '[图片]',
  'rooms.message_deleted': '此消息已被删除',
  'rooms.image_message': '图片消息',
  'rooms.delete_message': '删除消息',
  'rooms.no_messages': '暂无消息',
  'rooms.system': '系统',
  'rooms.member_list': '成员列表 — {name}',
  'rooms.joined_at': '加入于 {date}',
  'rooms.unknown_user': '未知用户',
  'rooms.no_members': '暂无成员',
  'rooms.mute_title': '静音群组',
  'rooms.mute_desc': '为 {name} 设置静音模式',
  'rooms.unmute_option': '取消静音',
  'rooms.player_mute': '成员静音（管理员可发言）',
  'rooms.full_mute': '全体静音',
  'rooms.delete_title': '删除群组',
  'rooms.delete_confirm':
    '确定要删除 {name} 吗？此操作不可撤销，所有消息和成员数据将被永久删除。',
  'rooms.confirm_delete': '确认删除',
  'rooms.assign_admin_title': '分配群组管理员',
  'rooms.assign_admin': '指定管理员',
  'rooms.admin_must_be_member': '管理员必须是群组成员',
  'rooms.assign_admin_desc': '为 {name} 指定管理员（可多选）',
  'rooms.current_admins': '当前管理员',
  'rooms.not_assigned': '未分配',
  'rooms.select_admins': '选择管理员',
  'rooms.select_admin_placeholder': '从群组成员中选择',
  'rooms.selected_count': '（已选 {count} 人）',
  'rooms.no_selectable_members': '暂无可选成员',
  'rooms.no_admins': '暂无管理员，请从上方添加',
  'rooms.deselect_note': '取消所有选择将移除全部管理员',
  'rooms.confirm_assign': '确认分配',
  'rooms.space_admin_title': '管理空间管理员',
  'rooms.space_admin_desc': '为 {name} 设置管理员（可多选）',
  'rooms.current_admin_badge': '当前管理员',
  'rooms.owner_note': '空间所有者不可被修改角色，取消所有选择将移除全部管理员',
  'rooms.confirm_save': '确认保存',
  'rooms.create_title': '在 {name} 中创建群聊',
  'rooms.upload_avatar': '上传头像',
  'rooms.room_name': '群聊名称',
  'rooms.room_name_placeholder': '例如：公告频道',
  'rooms.desc_optional': '描述（可选）',
  'rooms.desc_placeholder': '这个群聊是关于什么的？',
  'rooms.set_announcement': '设为公告频道',
  'rooms.set_private': '设为私密',
  'rooms.members': '成员',
  'rooms.create_room': '创建群聊',
  'rooms.create_room_desc': '在「{name}」中创建一个新的群聊',

  // Space Settings
  'space_settings.title': '群组设置',
  'space_settings.avatar': '群组头像',
  'space_settings.avatar_hint': '建议尺寸: 512x512px, 格式: JPG/PNG',
  'space_settings.upload_avatar': '上传头像',
  'space_settings.description': '群组介绍',
  'space_settings.no_description': '暂无介绍',
  'space_settings.space_type': '群组类型',
  'space_settings.private_space': '私密群组',
  'space_settings.private_desc': '需要邀请链接或邀请码才能加入',
  'space_settings.public_space': '公众群组',
  'space_settings.public_desc': '所有用户将自动加入此群组',
  'space_settings.external_verify': '外部账户验证',
  'space_settings.verify_enabled': '已启用 — 用户加入前需通过外部系统验证',
  'space_settings.verify_disabled': '已禁用 — 用户无需外部验证即可加入',
  'space_settings.verify_url_required': '启用外部账户验证时，验证URL不能为空',
  'space_settings.save_verify': '保存验证设置',
  'space_settings.invitation_link': '邀请链接',
  'space_settings.invitation_desc': '私密群组需要通过此邀请链接才能加入',
  'space_settings.no_link_placeholder': '暂无邀请链接，请点击生成',
  'space_settings.base_url_warning':
    '请先在 系统设置 → 功能开关 中配置「邀请链接基础URL」后，此处将显示完整邀请链接。',
  'space_settings.invitation_code': '邀请码: {code}',
  'space_settings.generate_failed': '生成邀请链接失败',
  'space_settings.suffix_invalid': '请输入2-3位数字作为邀请码后缀',
  'space_settings.regenerate': '重新生成',
  'space_settings.link_generated': '邀请链接生成成功',
  'space_settings.upload_avatar_failed': '上传头像失败',
  'space_settings.avatar_upload_success': '群组头像更新成功',
  'space_settings.confirm_make_public':
    '将此群组设为公开？所有用户将自动加入此群组。',
  'space_settings.confirm_make_private':
    '将此群组设为私密？只有拥有邀请链接或邀请码的用户才能加入。',

  // Report Management
  'reports.title': '举报管理',
  'reports.subtitle': '审核和处理用户举报',
  'reports.pending': '待处理',
  'reports.reviewing': '审核中',
  'reports.resolved': '已处理',
  'reports.rejected': '已驳回',
  'reports.search_placeholder': '搜索举报人、被举报人或群组...',
  'reports.type': '反馈信息',
  'reports.reporter': '举报人',
  'reports.reported_user': '被举报人',
  'reports.group': '群组',
  'reports.reason': '原因',
  'reports.priority': '优先级',
  'reports.time': '日期',
  'reports.type_harassment': '骚扰',
  'reports.type_spam': '垃圾信息',
  'reports.type_inappropriate': '不当内容',
  'reports.type_violence': '暴力威胁',
  'reports.type_other': '其他',
  // Report reason labels (from Flutter app)
  'reports.reason_bullying_harassment': '霸凌、骚扰或虐待',
  'reports.reason_violent_content': '暴力、仇恨或令人不安的内容',
  'reports.reason_suicide_self_harm': '自杀或自残',
  'reports.reason_restricted_items': '销售或推广受限物品',
  'reports.reason_adult_content': '成人内容',
  'reports.reason_scams_fraud': '诈骗、欺诈或虚假信息',
  'reports.reason_other': '其他原因',
  'reports.reason_threatening_nudes': '威胁要分享我的裸照',
  'reports.reason_sexual_exploitation': '似乎是性剥削',
  'reports.reason_human_trafficking': '似乎是人口贩卖',
  'reports.reason_bullying': '霸凌或骚扰',
  'reports.priority_low': '低',
  'reports.priority_medium': '中',
  'reports.priority_high': '高',
  'reports.priority_critical': '紧急',
  'reports.view_detail': '查看详情',
  'reports.mark_reviewing': '标记为审核中',
  'reports.mark_in_progress': '标记为处理中',
  'reports.view_profile': '查看用户资料',
  'reports.warn_user': '警告用户',
  'reports.send_warning_message': '向被举报用户发送警告消息',
  'reports.ban_user': '封禁用户',
  'reports.suspend_user': '暂停用户',
  'reports.reject_report': '驳回举报',
  'reports.reject_title': '驳回举报',
  'reports.reject_desc': '确认驳回对 {name} 的举报？',
  'reports.reject_notice_title': '提示',
  'reports.reject_notice_text':
    '驳回后，该举报将被标记为已驳回，不会对被举报用户采取任何措施。',
  'reports.reject_reason_label': '驳回原因',
  'reports.reject_reason_placeholder': '请输入驳回原因...',
  'reports.confirm_reject': '确认驳回',
  'reports.no_reports': '暂无举报记录',
  'reports.detail_title': '举报详情',
  'reports.detail_subtitle': '查看完整的举报信息和处理选项',
  'reports.report_type': '举报类型',
  'reports.related_group': '相关群组',
  'reports.report_reason': '举报原因',
  'reports.detail_description': '详细描述',
  'reports.reported_content': '被举报内容',
  'reports.submit_time': '提交时间',
  'reports.warn_title': '警告用户',
  'reports.warn_desc': '对用户 {name} 发出警告',
  'reports.warn_info': '警告将记录在用户档案中，多次警告可能导致账户被封禁。',
  'reports.warn_reason_label': '警告原因',
  'reports.warn_reason_placeholder': '请输入警告原因...',
  'reports.confirm_warn': '确认警告',
  'reports.ban_title': '封禁用户',
  'reports.ban_desc': '确认封禁用户 {name}？',
  'reports.ban_info':
    '封禁用户后，该用户将无法登录和使用平台功能。此操作可以在用户管理中撤销。',
  'reports.ban_reason_label': '封禁原因',
  'reports.ban_reason_placeholder': '请输入封禁原因...',
  'reports.confirm_ban': '确认封禁',
  'reports.evidence': '证据详情',
  'reports.evidence_images': '证据图片',
  'reports.report_history': '被举报人历史记录',
  'reports.reported_label': '被举报',
  'reports.warning_record': '警告记录',
  'reports.in_location': '在「{name}」',
  'reports.mute_user': '禁言',
  'reports.mute_title': '禁言用户',
  'reports.mute_desc': '禁止用户 {name} 在群组中发言',
  'reports.mute_info':
    '禁言后，该用户将无法在该群组的群聊中发表任何言论或图片。',
  'reports.mute_duration': '禁言时长',
  'reports.mute_select_duration': '选择禁言时长',
  'reports.mute_1day': '1天',
  'reports.mute_3days': '3天',
  'reports.mute_1week': '1星期',
  'reports.mute_1month': '1个月',
  'reports.mute_permanent': '直到被解封',
  'reports.confirm_mute': '确认禁言',

  // Admin Management
  'admin.title': '子账号管理',
  'admin.subtitle': '管理后台管理员账号和权限',
  'admin.search_placeholder': '搜索子账号姓名、用户名或邮箱...',
  'admin.create_admin': '+ 添加管理员',
  'admin.total_admins': '总子账号',
  'admin.active': '活跃',
  'admin.disabled': '已停用',
  'admin.admin_col': '子账号',
  'admin.owner': '所有者',
  'admin.admin_role': '管理员',
  'admin.you': '(你)',
  'admin.current_account': '当前账户',
  'admin.edit': '✏️ 编辑',
  'admin.disable': '停用',
  'admin.enable': '启用',
  'admin.transfer_ownership': '转让所有权',
  'admin.transfer_confirm':
    '确定将所有权转让给「{name}」？您将失去所有者权限。',
  'admin.transfer_failed': '转让失败',
  'admin.create_title': '创建子账号',
  'admin.unique_username': '唯一用户名',
  'admin.min_9_chars': '至少9个字符',
  'admin.edit_title': '编辑子账号: {name}',
  'admin.new_password': '新密码（留空保持不变）',

  // Admin Detail
  'admin.view_detail': '查看详情',
  'admin.back_to_list': '返回子账号列表',
  'admin.edit_profile': '编辑资料',
  'admin.change_password': '修改密码',
  'admin.disable_account': '停用账号',
  'admin.delete_account': '删除账号',
  'admin.account_info': '账号信息',
  'admin.activity_log': '操作记录',
  'admin.login_history': '登录历史',
  'admin.permission_count': '权限数量',
  'admin.last_login': '最后登录',
  'admin.department': '部门',
  'admin.edit_permissions': '编辑权限',
  'admin.edit_profile_title': '编辑子账号资料',
  'admin.edit_profile_desc': '修改子账号的基本信息',
  'admin.change_password_title': '修改密码',
  'admin.change_password_desc': '为子账号 {name} 设置新密码',
  'admin.new_password_input': '新密码',
  'admin.new_password_placeholder': '输入新密码...',
  'admin.confirm_password': '确认新密码',
  'admin.confirm_password_placeholder': '再次输入新密码...',
  'admin.confirm_change': '确认修改',
  'admin.passwords_mismatch': '两次输入的密码不一致',
  'admin.delete_title': '删除子账号',
  'admin.delete_confirm': '确认删除子账号 {name} 的账号？',
  'admin.delete_warning': '警告',
  'admin.delete_warning_text':
    '删除后该子账号将无法登录后台系统，此操作不可撤销。',
  'admin.confirm_delete': '确认删除',
  'admin.edit_permissions_title': '编辑子账号权限',
  'admin.edit_permissions_desc': '修改 {name} 的权限设置',
  'admin.admin_info': '子账号信息',
  'admin.no_activity': '暂无操作记录',
  'admin.no_login_history': '暂无登录记录',
  'admin.login_success': '成功',
  'admin.login_failed': '失败',
  'admin.role_label': '角色',
  'admin.upload_avatar': '上传头像',
  'admin.enable_account': '启用账号',

  // Platform Config
  'config.title': '系统设置',
  'config.subtitle': '配置平台基本功能和安全参数',
  'config.customer_support': '客服联系',
  'config.support_email_placeholder': '输入客服邮箱地址',
  'config.support_email_invalid': '请输入有效的邮箱地址',
  'config.qq_placeholder': '输入客服QQ号',
  'config.wechat_placeholder': '输入客服微信号',
  'config.telegram_placeholder': '输入客服Telegram账号',
  'config.support_hint': '用户可以通过以上方式联系客服团队',
  'config.app_download_links': 'APP下载链接',
  'config.ios_link_placeholder': '粘贴 iOS 下载链接',
  'config.android_link_placeholder': '粘贴 Android 下载链接',
  'config.mac_link_placeholder': '粘贴 macOS 下载链接',
  'config.windows_link_placeholder': '粘贴 Windows 下载链接',
  'config.download_page': 'APP下载页面',
  'config.download_page_placeholder': '粘贴下载页面链接',
  'config.member_mobile_links': '会员手机链接',
  'config.member_mobile_links_add': '添加链接',
  'config.member_mobile_links_empty': '尚未配置会员手机链接',
  'config.member_mobile_links_display_name_placeholder': '输入显示名称',
  'config.member_mobile_links_url_placeholder': '输入会员站点链接',
  'config.security_verification': '安全验证设置',
  'config.enable_login_captcha': '启用登录图形验证',
  'config.enable_login_captcha_desc':
    '用户登录时需要完成滑动拼图验证以提高安全性',
  'config.sensitive_words': '敏感词管理',
  'config.sensitive_words_list': '敏感词列表',
  'config.sensitive_words_placeholder': '输入敏感词，用逗号分隔',
  'config.sensitive_words_hint':
    '系统将自动过滤包含这些敏感词的消息内容。多个敏感词请用逗号分隔。',
  'config.terms_and_license': '条款与许可证',
  'config.select_content_to_edit': '请选择要编辑的内容',

  // My Account
  'account.title': '我的账号',
  'account.subtitle': '管理您的个人信息和账号设置',
  'account.avatar': '头像',
  'account.avatar_hint': '点击相机图标上传新头像',
  'account.avatar_formats': '支持 JPG、PNG 格式，文件大小不超过 5MB',
  'account.basic_info': '基本信息',
  'account.display_name': '姓名',
  'account.username': '用户名',
  'account.security': '安全设置',
  'account.login_password': '登录密码',
  'account.password_hint': '定期更改密码可以提高账号安全性',
  'account.change_password': '更改密码',
  'account.error_name_required': '显示名称不能为空',
  'account.error_name_min': '显示名称至少需要3个字符',
  'account.error_email_invalid': '请输入有效的邮箱地址',
  'account.error_mobile_invalid': '请输入有效的手机号码',
  'account.current_password': '当前密码',
  'account.current_password_placeholder': '输入当前密码',
  'account.new_password': '新密码',
  'account.new_password_placeholder': '输入新密码',
  'account.confirm_password': '确认新密码',
  'account.confirm_password_placeholder': '再次输入新密码',
  'account.change_password_desc':
    '请输入当前密码和新密码。新密码长度至少为9位，须包含大写字母、小写字母、数字和特殊字符。',
  'account.password_min_length': '密码至少需要9个字符',
  'account.password_needs_lowercase': '密码必须包含至少1个小写字母',
  'account.password_needs_uppercase': '密码必须包含至少1个大写字母',
  'account.password_needs_number': '密码必须包含至少1个数字',
  'account.password_needs_special': '密码必须包含至少1个特殊字符（@$!%*?&）',
  'account.passwords_mismatch': '两次输入的新密码不一致',
  'account.error_current_password_required': '请输入当前密码',
  'account.password_policy_hint':
    '至少9个字符，包含大写字母、小写字母、数字和特殊字符（@$!%*?&）',
  'account.email': '邮箱',
  'account.mobile': '手机号码',
  'account.avatar_invalid_format': '仅支持 JPG 和 PNG 格式',
  'account.avatar_too_large': '文件大小不能超过 5MB',
  'account.avatar_updated': '头像更新成功',

  // Permissions
  'permissions.title': '权限',
  'permissions.column': '权限',
  'permissions.users': '用户管理',
  'permissions.users_desc': '查看、编辑、删除用户',
  'permissions.spaces': '群组管理',
  'permissions.spaces_desc': '管理群组和群聊',
  'permissions.reports': '举报管理',
  'permissions.reports_desc': '处理用户举报',
  'permissions.sensitive_words': '敏感词管理',
  'permissions.sensitive_words_desc': '管理平台敏感词和内容过滤',
  'permissions.feedback': '用户反馈',
  'permissions.feedback_desc': '查看和管理用户反馈',
  'permissions.x_posts': '内容管理',
  'permissions.x_posts_desc': '管理内容爬虫、频道和帖子',
  'permissions.audit_logs': '审计日志',
  'permissions.audit_logs_desc': '查看系统操作记录',
  'permissions.settings': '系统设置',
  'permissions.settings_desc': '修改系统配置',
  'permissions.admins': '子账号管理',
  'permissions.admins_desc': '管理其他子账号',
  'config.general': '通用设置',
  'config.security': '安全设置',
  'config.notifications': '通知设置',
  'config.features': '功能开关',
  'config.avatars': '头像管理',
  'config.terms': '条款政策',
  'config.license': '许可证',
  'config.platform_info': '平台信息',
  'config.platform_name': '平台名称',
  'config.platform_desc': '平台简介',
  'config.contact_phone': '联系电话',
  'config.support_email': '客服邮箱',
  'config.qq': 'QQ',
  'config.wechat': '微信',
  'config.registration_settings': '用户注册设置',
  'config.username_registration': '用户名注册',
  'config.username_registration_desc': '用户使用用户名和密码进行注册和登录',
  'config.language_settings': '语言设置',
  'config.default_language': '默认语言',
  'config.default_language_desc': '设置平台默认显示语言',
  'config.simplified_chinese': '简体中文',
  'config.english': 'English',
  'config.data_management': '数据管理',
  'config.data_backup': '数据备份',
  'config.last_backup': '最后备份: 2024-03-27 02:00',
  'config.backup_now': '立即备份',
  'config.clear_cache': '清理缓存',
  'config.clear_cache_desc': '清理系统缓存数据以提升性能',
  'config.export_data': '导出数据',
  'config.export_data_desc': '导出所有平台数据',
  'config.export': '导出',
  'config.security_policy': '安全策略',
  'config.two_factor': '双因素认证',
  'config.two_factor_desc': '要求管理员启用双因素认证',
  'config.login_captcha': '登录图形验证',
  'config.login_captcha_desc': '用户登录时需要完成滑动拼图验证以提高安全性',
  'config.ip_whitelist': 'IP白名单',
  'config.ip_whitelist_desc': '仅允许白名单内的IP访问后台',
  'config.session_timeout': '会话超时时间（分钟）',
  'config.password_strength': '密码强度要求',
  'config.pwd_min_length': '至少8个字符',
  'config.pwd_upper_lower': '包含大小写字母',
  'config.pwd_numbers': '包含数字',
  'config.pwd_special': '包含特殊字符',
  'config.notification_events': '通知事件',
  'config.notif_new_user': '新用户注册',
  'config.notif_report': '用户举报提交',
  'config.notif_group_create': '群组创建',
  'config.notif_system_error': '系统异常',
  'config.notif_daily_report': '每日数据报告',
  'config.feature_control': '功能设置',
  'config.requires_mobile_number': '需要先开启手机号注册',
  'config.requires_email_enabled': '需要先开启邮箱注册',
  'config.input_placeholder': '输入{field}',
  'config.frequency.5min': '5 分钟',
  'config.frequency.10min': '10 分钟',
  'config.frequency.15min': '15 分钟',
  'config.frequency.20min': '20 分钟',
  'config.frequency.30min': '30 分钟',
  'config.frequency.1hour': '1 小时',
  'config.frequency.2hours': '2 小时',
  'config.frequency.3hours': '3 小时',
  'config.frequency.4hours': '4 小时',
  'config.frequency.6hours': '6 小时',
  'config.frequency.8hours': '8 小时',
  'config.frequency.12hours': '12 小时',
  'config.frequency.24hours': '24 小时',
  'config.otp_method.sms': '短信验证码',
  'config.otp_method.email': '邮箱验证码',
  'config.otp_method.off': '关闭',
  'config.allow_registration': '用户注册',
  'config.allow_registration_desc': '允许新用户注册账户',
  'config.allow_public_group': '公众群创建',
  'config.allow_public_group_desc': '允许用户创建公众群聊',
  'config.allow_private_group': '私密群创建',
  'config.allow_private_group_desc': '允许用户创建私密群聊',
  'config.allow_file_sharing': '文件分享',
  'config.allow_file_sharing_desc': '允许在群聊中分享文件',
  'config.allow_voice_messages': '语音消息',
  'config.allow_voice_messages_desc': '允许发送语音消息',
  'config.avatar_management': '预设头像管理',
  'config.upload_avatar': '+ 上传头像',
  'config.no_avatars': '暂无预设头像',
  'config.no_avatars_hint': '管理用户注册时可选择的预设头像',
  'config.upload_avatar_hint': '点击上传新头像',
  'config.upload_avatar_format': '支持 JPG、PNG 格式',
  'config.refresh_list': '刷新列表',
  'config.confirm_delete_avatar': '确定删除该头像？',
  'config.terms_title': '条款和隐私政策',
  'config.terms_placeholder': '在此输入条款和隐私政策内容...',
  'config.license_title': '许可证',
  'config.license_placeholder': '在此输入许可证内容...',
  'config.last_updated': '最后更新: {date}',

  // Platform Config Keys (from database)
  'platform_config.registration.requireCaptcha': '注册时需要图形验证码',
  'platform_config.registration.requireCaptcha_desc':
    '用户注册时需要输入图形验证码',
  'platform_config.registration.requireMobileNumber': '注册时需要手机号',
  'platform_config.registration.requireMobileNumber_desc':
    '用户注册时必须提供手机号码',
  'platform_config.registration.requireOtp': '注册时需要短信验证码',
  'platform_config.registration.requireOtp_desc': '用户注册时需要验证手机号',
  'platform_config.registration.otpMethod': 'OTP 验证方式',
  'platform_config.registration.otpMethod_desc':
    '选择验证方式：短信、邮箱或关闭',
  'platform_config.registration.requireEmail': '注册时需要邮箱地址',
  'platform_config.registration.requireEmail_desc':
    '用户注册时必须提供邮箱地址',
  'platform_config.registration.requireEmailVerification':
    '注册时需要邮箱验证码',
  'platform_config.registration.requireEmailVerification_desc':
    '用户注册时需要验证邮箱',
  'platform_config.security.loginCaptcha': '启用登录图形验证',
  'platform_config.security.loginCaptcha_desc':
    '用户登录时需要输入验证码以提高安全性',
  'platform_config.features.maxFileSizeMB': '文件大小限制（MB）',
  'platform_config.features.maxFileSizeMB_desc': '上传文件的最大大小（MB）',
  'platform_config.features.maxGroupMembers': '群聊成员上限',
  'platform_config.features.maxGroupMembers_desc': '每个群聊的最大成员数',
  'platform_config.x_crawl_frequency_minutes': '抓取频率（分钟）',
  'platform_config.x_crawl_frequency_minutes_desc':
    '从 X 频道获取新帖子的间隔时间（5–1440）',
  'platform_config.x_crawl_max_posts_per_channel': '每频道每次最大抓取数',
  'platform_config.x_crawl_max_posts_per_channel_desc':
    '每次抓取每个频道最多获取的帖子数量（1–20）',
  'platform_config.invitation.baseUrl':
    '邀请链接基础URL（例如：https://example.com/invite）',
  'platform_config.invitation.baseUrl_desc': '用于生成邀请链接的基础URL',
  'platform_config.jpush.app_key': 'JPush App Key',
  'platform_config.jpush.app_key_desc': '极光推送应用密钥',
  'platform_config.jpush.master_secret': 'JPush Master Secret',
  'platform_config.jpush.master_secret_desc': '极光推送主密钥',

  // Audit Logs
  'audit.title': '审计日志',
  'audit.subtitle': '查看系统操作记录和变更历史',
  'audit.admin': '管理员',
  'audit.admin_id': '管理员ID',
  'audit.all_modules': '全部模块',
  'audit.all_actions': '全部操作',
  'audit.search_placeholder': '搜索管理员用户名...',
  'audit.module': '功能',
  'audit.start_date': '开始日期',
  'audit.end_date': '结束日期',
  'audit.no_logs': '暂无审计日志',
  'audit.date_range_exceeded': '日期范围不能超出{days}天',
  'audit.date_range_invalid': '开始日期必须早于结束日期',
  'audit.timestamp': '时间',
  'audit.description': '详情',
  'audit.details': '详情',
  'audit.changes': '变更内容',
  'audit.field': '字段',
  'audit.before': '变更前',
  'audit.after': '变更后',
  'audit.deleted_values': '已删除的值',
  // Module names (matches sidebar navigation)
  'audit.module.user': '用户管理',
  'audit.module.space': '群组管理',
  'audit.module.report': '举报管理',
  'audit.module.feedback': '用户反馈',
  'audit.module.admin': '子账号管理',
  'audit.module.settings': '系统设置',
  'audit.module.x_posts': '内容管理',
  'audit.module.unknown': '其他',
  // Action descriptions
  'audit.action.CREATE_USER': '创建用户',
  'audit.action.UPDATE_USER': '更新用户',
  'audit.action.BAN_USER': '封禁用户',
  'audit.action.UNBAN_USER': '解封用户',
  'audit.action.MUTE_USER': '禁言用户',
  'audit.action.UNMUTE_USER': '解除禁言',
  'audit.action.DELETE_USER': '删除用户',
  'audit.action.CREATE_SPACE_OWNER': '创建空间主',
  'audit.action.UPDATE_SPACE_OWNER': '更新空间主',
  'audit.action.ENABLE_SPACE_OWNER': '启用空间主',
  'audit.action.DISABLE_SPACE_OWNER': '禁用空间主',
  'audit.action.CREATE_SPACE': '创建空间',
  'audit.action.UPDATE_SPACE': '更新空间',
  'audit.action.UPDATE_SPACE_VERIFICATION': '更新空间验证',
  'audit.action.REASSIGN_SPACE_OWNER': '转让空间所有权',
  'audit.action.DEACTIVATE_SPACE': '停用空间',
  'audit.action.ACTIVATE_SPACE': '激活空间',
  'audit.action.DELETE_SPACE': '删除空间',
  'audit.action.ADD_SPACE_MEMBERS': '添加空间成员',
  'audit.action.REMOVE_SPACE_MEMBER': '移除空间成员',
  'audit.action.SET_SPACE_ADMINS': '设置空间管理员',
  'audit.action.CREATE_ROOM': '创建群聊',
  'audit.action.UPDATE_ROOM': '更新群聊',
  'audit.action.DELETE_ROOM': '删除群聊',
  'audit.action.ADD_ROOM_MEMBERS': '添加群聊成员',
  'audit.action.REMOVE_ROOM_MEMBER': '移除群聊成员',
  'audit.action.ASSIGN_ROOM_ADMINS': '设置群聊管理员',
  'audit.action.SET_ROOM_MUTE': '设置群聊禁言',
  'audit.action.DELETE_MESSAGE': '删除消息',
  'audit.action.GENERATE_INVITATION_CODES': '生成邀请码',
  'audit.action.GENERATE_SPACE_INVITATION_LINK': '生成空间邀请链接',
  'audit.action.UPDATE_INVITATION_BASE_URL': '更新邀请链接基础URL',
  'audit.action.ADD_SENSITIVE_WORD': '添加敏感词',
  'audit.action.BATCH_UPLOAD_SENSITIVE_WORDS': '批量上传敏感词',
  'audit.action.REMOVE_SENSITIVE_WORD': '删除敏感词',
  'audit.action.REPLACE_PLATFORM_SENSITIVE_WORDS': '替换平台敏感词',
  'audit.action.UPDATE_CONTENT': '更新内容',
  'audit.action.UPDATE_PLATFORM_CONFIG': '更新系统配置',
  'audit.action.SEND_NOTIFICATION': '发送通知',
  'audit.action.WARN_REPORTED_USER': '警告被举报用户',
  'audit.action.UPDATE_FEEDBACK_STATUS': '更新反馈状态',
  'audit.action.ADD_FEEDBACK_REPLY': '添加反馈回复',
  'audit.action.BACKOFFICE_ADMIN_CREATED': '创建后台管理员',
  'audit.action.BACKOFFICE_ADMIN_UPDATED': '更新后台管理员',
  'audit.action.BACKOFFICE_OWNERSHIP_TRANSFERRED': '转让后台所有权',
  'audit.action.CREATE_CATEGORY': '创建分类',
  'audit.action.UPDATE_CATEGORY': '更新分类',
  'audit.action.DELETE_CATEGORY': '删除分类',
  'audit.action.CONVERT_ROOM_TO_PRIVATE': '将群聊转为私密',
  'audit.action.CONVERT_ROOM_TO_PUBLIC': '将群聊转为公开',
  'audit.action.CREATE_X_POST': '创建帖子',
  'audit.action.UPDATE_X_POST': '更新帖子',
  'audit.action.DELETE_X_POST': '删除帖子',
  'audit.action.PUBLISH_X_POST': '发布帖子',
  'audit.action.UNPUBLISH_X_POST': '取消发布帖子',
  'audit.action.TRIGGER_CRAWL': '触发抓取',

  // Invitation Codes
  'invitation.base_url_title': '🔗 邀请链接基础URL配置',
  'invitation.base_url_desc':
    '设置邀请链接的基础URL，生成的邀请链接将以此URL为前缀。例如：https://example.com/invite',
  'invitation.current_base_url': '当前基础URL：',
  'invitation.current_link_title': '🔗 当前邀请链接',
  'invitation.invitation_link_label': '邀请链接：',
  'invitation.no_base_url_warning':
    '⚠️ 未配置基础URL，请先在上方设置邀请链接基础URL以生成完整链接。',
  'invitation.no_active_code': '暂无有效邀请码，请在下方生成。',
  'invitation.generate_new': '🔄 生成新邀请码',
  'invitation.generate_revokes': '（撤销当前）',
  'invitation.generate_warning':
    '生成新邀请码将撤销该群组所有现有未使用的邀请码。',
  'invitation.confirm_generate':
    '此操作将撤销该群组所有现有未使用的邀请码。是否继续？',
  'invitation.code_history': '邀请码历史',
  'invitation.usage_logs': '使用记录',
  'invitation.hide_usage_logs': '隐藏使用记录',
  'invitation.view_usage_logs': '查看使用记录',
  'invitation.filter': '筛选：',
  'invitation.active': '有效',
  'invitation.code': '邀请码',
  'invitation.link': '邀请链接',
  'invitation.status_revoked': '已撤销',
  'invitation.status_used': '已使用',
  'invitation.status_active': '有效',
  'invitation.used_by': '使用者',
  'invitation.used_at': '使用时间',
  'invitation.created': '创建时间',
  'invitation.no_codes': '暂无邀请码',
  'invitation.no_base_url': '未配置基础URL',
  'invitation.copy_code': '邀请码',
  'invitation.copy_link': '链接',
  'invitation.no_usage_logs': '暂无使用记录',
  'invitation.title': '邀请码管理',
  'invitation.space_owner': '群组所有者',
  'invitation.space': '群组',
  'invitation.no_spaces': '暂无群组',
  'invitation.active_codes': '有效邀请码',
  'invitation.used': '已使用',
  'invitation.revoked': '已撤销',
  'invitation.total_generated': '总生成数',
  'invitation.copied': '✓ 已复制',
  'invitation.copy': '📋 复制邀请码',

  // Feedback Management
  'nav.feedback': '用户反馈',

  // Posts
  'nav.x_posts': '内容管理',

  'feedback.title': '用户反馈',
  'feedback.subtitle': '查看和管理用户提交的反馈和建议',
  'feedback.pending': '待处理',
  'feedback.processing': '处理中',
  'feedback.resolved': '已解决',
  'feedback.closed': '已关闭',
  'feedback.total': '总反馈数',
  'feedback.search_placeholder': '搜索反馈标题、内容或用户...',
  'feedback.all_status': '全部状态',
  'feedback.all_types': '全部类型',
  'feedback.type_feature_request': '功能请求',
  'feedback.type_bug_report': '问题反馈',
  'feedback.type_suggestion': '建议',
  'feedback.type_other': '其他',
  'feedback.feedback_title': '反馈标题',
  'feedback.type': '类型',
  'feedback.status': '状态',
  'feedback.submitted_at': '提交时间',
  'feedback.back_to_list': '返回反馈列表',
  'feedback.reply_count': '回复记录 ({count})',
  'feedback.no_replies': '暂无回复',
  'feedback.reply_placeholder': '输入回复内容...',
  'feedback.internal_note': '内部备注（用户不可见）',
  'feedback.send_reply': '发送回复',
  'feedback.reply_sent': '回复发送成功',
  'feedback.upload_image': '上传图片',
  'feedback.upload': '上传',
  'feedback.management': '管理',
  'feedback.save_changes': '保存更改',
  'feedback.info': '反馈信息',
  'feedback.feedback_id': '反馈ID',
  'feedback.submitted_time': '提交时间',
  'feedback.last_updated': '最后更新',
  'feedback.screenshots': '截图',
  'feedback.user_info': '用户信息',
  'feedback.device': '设备',
  'feedback.version': '版本',
  'feedback.no_feedback': '暂无反馈',
  'feedback.admin_badge': '管理员',

  // Chatroom Detail
  'chatroom.back_to_space': '返回群聊详情',
  'chatroom.total_members': '总成员数',
  'chatroom.total_messages': '总消息数',
  'chatroom.admin_count': '管理员',
  'chatroom.created_date': '创建日期',
  'chatroom.created_on': '创建于 {date}',
  'chatroom.view_messages': '查看消息',
  'chatroom.edit_room': '编辑群聊',
  'chatroom.edit_room_desc': '修改群聊的基本信息',
  'chatroom.room_name': '群聊名称',
  'chatroom.room_name_placeholder': '输入群聊名称',
  'chatroom.description_placeholder': '输入群聊描述',
  'chatroom.view_all_members': '查看所有成员',
  'chatroom.settings': '群聊设置',
  'chatroom.room_avatar': '群聊头像',
  'chatroom.description': '群聊介绍',
  'chatroom.no_description': '暂无介绍',
  'chatroom.room_type': '群聊性质',
  'chatroom.public_room': '公开群聊',
  'chatroom.public_room_desc': '群组内所有成员可见和加入',
  'chatroom.private_room': '私密群聊',
  'chatroom.private_room_desc': '仅受邀成员可加入和查看',
  'chatroom.mute_settings': '禁言设置',
  'chatroom.allow_member_chat': '允许成员发言',
  'chatroom.allow_member_chat_desc': '所有成员都可以发送消息',
  'chatroom.announcement_settings': '公告设置',
  'chatroom.set_as_announcement': '设置为公告群',
  'chatroom.set_as_announcement_desc': '仅管理员可发送消息，成员只能查看',
  'chatroom.announcement_enabled': '已设置为公告群',
  'chatroom.announcement_enabled_desc': '仅管理员可以发送消息',
  'chatroom.only_admins_can_send': '仅管理员可以发送消息',
  'chatroom.all_members_can_send': '所有成员都可以发送消息',
  'chatroom.confirm_set_announcement':
    '将此群聊设置为公告群？仅管理员可以发送消息。',
  'chatroom.confirm_unset_announcement':
    '取消公告群设置？所有成员将可以发送消息。',
  'chatroom.save_all_settings': '保存所有设置',
  'chatroom.confirm_allow_chat': '允许所有成员在此群聊中发送消息？',
  'chatroom.confirm_mute_chat': '禁言所有成员？只有管理员可以发送消息。',
  'chatroom.avatar_upload_success': '群聊头像更新成功',
  'chatroom.avatar_upload_failed': '群聊头像上传失败',
  'chatroom.room_admins': '群聊管理员',
  'chatroom.view_profile': '查看资料',
  'chatroom.remove_admin': '移除管理员',
  'chatroom.confirm_remove_admin': '确认移除 {name} 的管理员身份？',
  'chatroom.admin_name': '管理员',
  'chatroom.role': '角色',
  'chatroom.assigned_date': '指定日期',
  'chatroom.room_members': '群聊成员',
  'chatroom.view_all': '查看全部',
  'chatroom.member_name': '成员',
  'chatroom.join_date': '加入日期',
  'chatroom.message_count': '消息数',
  'chatroom.role_admin': '管理员',
  'chatroom.role_owner': '群组所有者',
  'chatroom.role_space_admin': '群组管理员',
  'chatroom.role_member': '成员',
  'chatroom.back_to_detail': '返回群聊详情',
  'chatroom.add_member_title': '添加群聊成员',
  'chatroom.add_member_desc': '搜索并添加用户到群聊「{name}」',
  'chatroom.member_list_title': '成员列表',
  'chatroom.total_count': '共 {count} 位成员',
  'chatroom.active_members': '活跃成员',
  'chatroom.search_member_placeholder': '搜索成员名称、用户名ID...',
  'chatroom.filter_all': '全部成员',
  'chatroom.filter_admin': '管理员',
  'chatroom.filter_member': '普通成员',
  'chatroom.last_active': '最后活跃',
  'chatroom.confirm_convert_private':
    '确定将此聊天室转为私密？仅受邀成员可以访问。',
  'chatroom.confirm_convert_public':
    '确定将此聊天室转为公开？所有空间成员均可访问。',
  'chatroom.converting_visibility': '转换中...',
  'chatroom.owner_dm': '群主私信',
  'chatroom.friend_dm': '好友私信',
  'chatroom.locked': '已锁定',

  // Chat History
  'chathistory.back_to_detail': '返回群聊详情',
  'chathistory.total_messages': '总消息数',
  'chathistory.reported_messages': '已标记消息',
  'chathistory.blocked_count': '被禁言成员',
  'chathistory.active_members': '活跃成员',
  'chathistory.members_label': '成员',
  'chathistory.messages_label': '条消息',
  'chathistory.search_placeholder': '搜索消息内容或发送者...',
  'chathistory.filter_all': '全部消息',
  'chathistory.filter_normal': '正常消息',
  'chathistory.filter_reported': '已标记',
  'chathistory.flagged': '已标记',
  'chathistory.delete_confirm': '确定要删除这条消息吗？此操作不可撤销。',
  'chathistory.message_deleted': '消息已删除',
  'chathistory.attachment': '附件',
  'chathistory.view_image': '查看图片',

  // Form Validation
  'validation.username_min_length': '用户名至少需要6个字符',
  'validation.username_max_length': '用户名不能超过50个字符',
  'validation.username_alphanumeric': '用户名只能包含字母和数字',
  'validation.display_name_min_length': '显示名称至少需要6个字符',
  'validation.admin_display_name_min_length': '显示名称至少需要3个字符',
  'validation.display_name_max_length': '显示名称不能超过50个字符',
  'validation.password_min_length': '密码至少需要9个字符',
  'validation.password_needs_lowercase': '密码必须包含至少1个小写字母',
  'validation.password_needs_uppercase': '密码必须包含至少1个大写字母',
  'validation.password_needs_number': '密码必须包含至少1个数字',
  'validation.password_needs_special': '密码必须包含至少1个特殊字符（@$!%*?&）',
  'validation.mobile_format': '手机号码必须为6-15位数字',
  'validation.mobile_invalid_for_country': '手机号码格式与所选国家不匹配',
  'validation.country_code_format': '无效的国家代码',
  'validation.contains_masked_content': '不能保存已屏蔽的内容，请输入实际值',
  'validation.email_invalid': '请输入有效的邮箱地址',
  'validation.email_required': '邮箱为必填项',
  'validation.permissions_required': '至少需要分配一个权限',
  'validation.space_name_min_length': '频道名称至少需要3个字符',
  'validation.space_name_max_length': '频道名称不能超过100个字符',
  'validation.description_min_length': '描述至少需要10个字符',
  'validation.description_max_length': '描述不能超过1000个字符',
  'validation.visibility_required': '请选择频道类型',
  'validation.owner_required': '请选择频道所有者',
  'validation.url_invalid': '请输入有效的URL',
  'validation.password_hint':
    '至少9个字符，须包含大写字母、小写字母、数字和特殊字符（@$!%*?&）',

  // Toast Messages
  'toast.user_created': '用户创建成功',
  'toast.user_updated': '用户更新成功',
  'toast.user_deleted': '用户删除成功',
  'toast.user_banned': '用户封禁成功',
  'toast.user_unbanned': '用户解封成功',
  'toast.user_muted': '用户禁言成功',
  'toast.user_unmuted': '用户解除禁言成功',
  'toast.user_create_failed': '创建用户失败',
  'toast.user_update_failed': '更新用户失败',
  'toast.user_delete_failed': '删除用户失败',
  'toast.user_ban_failed': '封禁用户失败',
  'toast.user_unban_failed': '解封用户失败',
  'toast.user_mute_failed': '禁言用户失败',
  'toast.user_unmute_failed': '解除禁言失败',
  'toast.space_created': '群组创建成功',
  'toast.space_updated': '群组更新成功',
  'toast.space_status_updated': '群组状态已更新',
  'toast.space_deleted': '群组删除成功',
  'toast.space_delete_failed': '删除群组失败',
  'toast.space_admins_updated': '管理员更新成功',
  'toast.ownership_transferred': '所有权转让成功',
  'toast.room_created': '群聊创建成功',
  'toast.room_mute_updated': '群聊静音设置已更新',
  'toast.room_deleted': '群聊删除成功',
  'toast.room_admins_updated': '群聊管理员已更新',
  'toast.members_added': '成员添加成功',
  'toast.space_create_failed': '创建群组失败',
  'toast.space_update_failed': '更新群组失败',
  'toast.space_status_update_failed': '更新群组状态失败',
  'toast.space_admins_update_failed': '更新管理员失败',
  'toast.ownership_transfer_failed': '转让所有权失败',
  'toast.room_create_failed': '创建群聊失败',
  'toast.room_mute_update_failed': '更新静音设置失败',
  'toast.room_delete_failed': '删除群聊失败',
  'toast.room_admins_update_failed': '更新群聊管理员失败',
  'toast.members_add_failed': '添加成员失败',
  'toast.admin_created': '子账号创建成功',
  'toast.admin_updated': '子账号更新成功',
  'toast.admin_deleted': '子账号删除成功',
  'toast.admin_create_failed': '创建子账号失败',
  'toast.admin_update_failed': '更新子账号失败',
  'toast.admin_delete_failed': '删除子账号失败',
  'toast.room_updated': '群聊更新成功',
  'toast.room_update_failed': '群聊更新失败',
  'toast.member_removed': '成员已移除',
  'toast.member_remove_failed': '移除成员失败',
  'toast.message_deleted': '消息已删除',
  'toast.message_delete_failed': '删除消息失败',
  'toast.report_updated': '举报状态已更新',
  'toast.user_warned': '已向用户发送警告',

  // Common (additional)
  'common.upload_failed': '上传失败',

  // Posts Management
  'x_posts.title': '内容管理',
  'x_posts.subtitle': '已采集 {total} 篇帖子，来自 {channels} 个频道',
  'x_posts.create_post': '+ 新建帖子',
  'x_posts.fetch_posts': '抓取帖子',
  'x_posts.fetching_posts': '抓取中...',
  'x_posts.search_placeholder': '搜索帖子...',
  'x_posts.all_topics': '全部主题',
  'x_posts.no_posts': '暂无帖子。请调整筛选条件或等待下次抓取。',
  'x_posts.add_username_placeholder': '添加 @用户名',
  'x_posts.add_btn': '添加',
  'x_posts.original_text_placeholder': '原文（英文）',
  'x_posts.translation_placeholder': '翻译文本（中文）— 可选',
  'x_posts.content_placeholder': '帖子内容',
  'x_posts.content_label': '内容',
  'x_posts.create_btn': '创建',
  'x_posts.creating': '创建中...',
  'x_posts.cancel': '取消',
  'x_posts.summary_label': '摘要 / 描述',
  'x_posts.summary_placeholder': '摘要或翻译描述',
  'x_posts.topics_label': '主题',
  'x_posts.upload': '上传',
  'x_posts.regenerate': 'AI 重新生成',
  'x_posts.save_title': '保存',
  'x_posts.cancel_title': '取消',
  'x_posts.edit_title': '编辑摘要和主题',
  'x_posts.publish_title': '发布',
  'x_posts.unpublish_title': '取消发布',
  'x_posts.delete_title': '删除',
  'x_posts.delete_confirm': '确定删除此帖子？',
  'x_posts.topic_required': '请选择一个分类',
  'x_posts.content_required': '帖子必须包含文字或至少一张图片',
  'x_posts.remove_channel_confirm': '确定移除 @{username}？',
  'x_posts.fetch_channel_title': '抓取 @{username}',
  'x_posts.all_status': '全部状态',
  'x_posts.status.posted': '已发布',
  'x_posts.status.held': '未发布',
  'x_posts.hold_reason.sensitive': '敏感',
  'x_posts.hold_reason.error': '未审核',
  'x_posts.hold_reason.unposted': '未发布',
  'x_posts.topic.politics': '政治',
  'x_posts.topic.economy': '财经',
  'x_posts.topic.tech': '科技',
  'x_posts.topic.sports': '体育',
  'x_posts.topic.entertainment': '娱乐',
  'x_posts.topic.other': '其他',
  'x_posts.toast.post_deleted': '帖子已删除',
  'x_posts.toast.delete_failed': '删除失败',
  'x_posts.toast.published': '帖子已发布',
  'x_posts.toast.unpublished': '帖子已取消发布',
  'x_posts.toast.toggle_failed': '发布状态切换失败',
  'x_posts.toast.post_updated': '帖子已更新',
  'x_posts.toast.update_failed': '更新失败',
  'x_posts.toast.post_created': '帖子已创建',
  'x_posts.toast.create_failed': '创建帖子失败',
  'x_posts.toast.crawl_queued': '抓取任务已入队 — 帖子稍后将出现',
  'x_posts.toast.channel_crawl_queued': '正在抓取频道帖子...',
  'x_posts.toast.crawl_failed': '触发抓取失败',
  'x_posts.toast.channel_added': '已添加 @{username}',
  'x_posts.toast.channel_add_failed': '添加频道失败',
  'x_posts.toast.channel_removed': '已移除 @{username}',
  'x_posts.toast.channel_remove_failed': '移除频道失败',
  'x_posts.toast.upload_failed': '上传 {name} 失败',
  'x_posts.view_original': '查看原文',
  'x_posts.toast.classify_queued': '分类任务已入队',
  'x_posts.toast.classify_failed': '分类失败',
  'x_posts.toast.generate_image_queued': '生成图片任务已入队',
  'x_posts.toast.generate_image_failed': '生成图片失败',
  'x_posts.toast.generate_thumbnails_success':
    '缩略图生成完成：{{processed}} 已处理，{{failed}} 失败',
  'x_posts.toast.generate_thumbnails_failed': '生成缩略图失败',
  'x_posts.toast.translate_images_queued': '翻译图片任务已入队',
  'x_posts.toast.translate_images_failed': '翻译图片失败',
  'x_posts.toast.jobs_cancelled': '所有待处理任务已取消',
  'x_posts.toast.cancel_failed': '取消任务失败',
  'x_posts.classify_title': '分类帖子',
  'x_posts.generate_image_title': '生成图片',
  'x_posts.generate_thumbnails': '生成缩略图',
  'x_posts.translate_images_title': '翻译图片',
  'x_posts.cancel_jobs': '取消',
  'x_posts.sync_followings': '同步频道',
  'x_posts.syncing_followings': '同步中...',
  'x_posts.toast.sync_followings_success': '频道同步成功',
  'x_posts.toast.sync_followings_failed': '同步频道失败',
};

export default zh;
